import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { ToastService } from '../../../services/toast.service';
import { SubscriptionService } from '../../../services/subscription.service';

@Component({
  selector: 'app-design-partner-login',
  templateUrl: './design-partner-login.component.html',
  styleUrls: ['./design-partner-login.component.scss'],
})
export class DesignPartnerLoginComponent {
  email: string = '';
  password: string = '';
  showPassword: boolean = false;
  isSubmitting: boolean = false;
  validationErrors: Record<string, string> = {};

  constructor(
    private authService: AuthService,
    private router: Router,
    private toaster: ToastService,
    private subscriptionService: SubscriptionService
  ) {}

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  validateForm(): boolean {
    this.validationErrors = {};

    if (!this.email || !this.isValidEmail(this.email)) {
      this.validationErrors['email'] = 'Please enter a valid email';
    }

    if (!this.password || this.password.length < 8) {
      this.validationErrors['password'] = 'Password must be at least 8 characters';
    }

    return Object.keys(this.validationErrors).length === 0;
  }

  hasError(field: string): boolean {
    return !!this.validationErrors[field];
  }

  login(): void {
    if (!this.validateForm()) {
      const firstError = Object.values(this.validationErrors)[0];
      this.toaster.showToast(firstError, 'error');
      return;
    }

    this.isSubmitting = true;
    const payload = {
      email: this.email.trim().toLowerCase(),
      password: this.password,
    };

    this.authService.loginDesignPartner(payload).subscribe({
      next: (response: any) => {
        const userToStore = {
          _id: response.user._id,
          email: response.user.email,
          name: response.user.contact_name || response.user.name,
          company_name: response.user.company_name,
          role: response.user.is_design_partner? 'design_partner': 'user',
          is_email_verified: response.user.is_email_verified,
          is_active: response.user.is_active,
        };

        if (response.subscription) {
          this.subscriptionService.setSubcription(response.subscription);
        }

        this.authService.setAuthData(response.token, userToStore);
        this.isSubmitting = false;
        this.toaster.showToast('Login successful!', 'success');
        this.router.navigate(['/'], { replaceUrl: true });
      },
      error: (error) => {
        this.isSubmitting = false;
        const message =
          error?.error?.message ||
          error?.error?.error ||
          'Invalid email or password';
        this.toaster.showToast(message, 'error');
      },
    });
  }

  togglePasswordVisibility(passwordInput: HTMLInputElement): void {
    this.showPassword = !this.showPassword;
    passwordInput.type = this.showPassword ? 'text' : 'password';
  }

  navigateToRegister(): void {
    this.router.navigate(['/auth/register/design-partner']);
  }

  navigateToUserLogin(): void {
    this.router.navigate(['/auth']);
  }

  navigateToForgotPassword(): void {
    this.router.navigate(['/auth/forgot-password']);
  }
}
